import { State } from '../state.interface';
import * as Actions from '../actions';
import { assocPath } from 'ramda';

export const setIsOverridableReducer = (state: State, action: Actions.IsOverridable) =>
  assocPath(['variableConfiguration', 'is_overridable'], action.payload.isOverridable, state);
